/**
 * Centralized React Query key factory for AIChatWidget TOS queries.
 *
 * Using a single factory ensures queries and mutations reference identical
 * keys so `invalidateQueries` triggers refetch correctly.
 */
export const tosKeys = {
    all: ['ai-tos'],
    status: () => [...tosKeys.all, 'status']
};
